import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faFire, faMugHot, faSnowflake } from '@fortawesome/pro-solid-svg-icons'

import { snakeToTitleCase } from '@campaignhub/javascript-utils'

import Box from '../../Box'
import Text from '../../Text'

export const formatter =  Intl.NumberFormat('en-US', {
  style: 'percent',
})

const icons = {
  cold: faSnowflake,
  hot: faFire,
  warm: faMugHot,
}

const CustomLegend = (props) => {
  const { formattedNumber, formattedString, payload } = props

  return (
    <Box
      alignItems="center"
      flexDirection="row"
      flexWrap="wrap"
      justifyContent="center"
      marginTop="large"
      padding="medium"
    >
      {payload.map((item) => {
        const {
          color,
          payload: { percent, stroke },
          value,
        } = item

        return (
          <Box key={value} marginTop="medium" width="auto">
            <Text fontSize="xxsmall" color={icons[value] ? stroke : color}>
              <FontAwesomeIcon icon={icons[value] || faCircle} />
            </Text>

            <Text
              color="bodyFontLightColor"
              fontSize="xxsmall"
              marginLeft="small"
              marginRight="medium"
            >
             { `${formattedString || snakeToTitleCase(value)} ${formattedNumber || formatter.format(percent)}` }
            </Text>
          </Box>
        )
      })}
    </Box>
  )
}

CustomLegend.propTypes = {
  formattedNumber: PropTypes.number.isRequired,
  formattedString: PropTypes.string,
  payload: PropTypes.array,
}

export default CustomLegend
